import * as React from 'react';

import './LiveTicker.scss'
import { EventEntry } from './EventEntry';
import { DetailedTickerMatchState, TickerMatch } from '../../../models';

// @ts-ignore
import { SwipeableViewsContext } from 'react-swipeable-views';

interface Props {
  match: TickerMatch
  matchState: DetailedTickerMatchState
}

export const LiveTicker = (props: Props) => {

    const { matchState } = props

    const context: any = React.useContext(SwipeableViewsContext);
    React.useEffect(() => {
        context.slideUpdateHeight()
    }, [matchState.eventHistory])

    const eventHistory = matchState.eventHistory
    return <div className="LiveTicker">
      {eventHistory.map((e, i) => <div key={i}><EventEntry key={e.uuid} event={e} {...props} /></div>)}
    </div>

}
